import {
  arrayBufferDownload,
  arrayBufferDownloadExcel,
  downloadCSV,
} from "../../../../utils/download";
import {
  decorateEmptyGridValues,
  setColumnDefaultExtraProps,
} from "../../../../utils/table/gridUtils";
import {
  FETCH_RATEADMIN_ADVANCERATE_LIST,
  TOAST,
  FETCH_RATEADMIN_ADVANCERATE_INIT,
  FETCH_RATEADMIN_ADVANCERATE_DETAIL,
  EXPORT_RATEADMIN_ADVANCERATE,
  CREATE_RATEADMIN_ADVANCERATE,
  EDIT_RATEADMIN_ADVANCERATE,
  INIT_CREATE_RATEADMIN_ADVANCERATE_SCREEN,
  RATEADMIN_ADVANCERATEDD,
  RATEADMIN_ADVANCERATE_DELETE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  RATEADMIN_ADVANCERATE_SAVE_TABLE_STATE,
  SEARCH_ADVANCE_RATE,
  UPDATE_ADVANCE_RATE,
} from "../../../types/RateAdmin/rateadminadvancerate.type";
import { formatDatesMmDdYyyy } from "../../../../utils";

const formFieldValueMap = {
  id: null,
  rateOption: 0,
  startDate: "",
  endDate: "",
  fkCategory: 0,
  fkLocationId: 0,
  fkNetworkId: 0,
  fkRateGroup: 0,
  fkRateTypeId: 0,
  status: 1,
  userId: "",
  excludeWeekends: false,
  // Weekday rates
  weekdayDailyRate: "0",
  weekdayDailyMiles: "0",
  weekdayWeeklyRate: "0",
  weekdayWeeklyMiles: "0",
  weekdayMonthlyRate: "0",
  weekdayMonthlyMiles: "0",
  weekdayExtraHourRate: "0",
  weekdayExtraMileRate: "0",
  // Weekend rates
  weekendDailyRate: "0",
  weekendDailyMiles: "0",
  weekendWeeklyRate: "0",
  weekendWeeklyMiles: "0",
  weekendMonthlyRate: "0",
  weekendMonthlyMiles: "0",
  weekendExtraHourRate: "0",
  weekendExtraMileRate: "0",
};

const INITIAL_STATE = {
  rateAdminAdvanceRateListview: [],
  AdvanceRateDD: [],
  isRateAdminAdvanceRateDDSuccess: false,
  isRateAdminAdvanceRateDDError: false,
  isRateAdminAdvanceRateDeleteSuccess: false,
  isRateAdminAdvanceRateDeleteError: false,
  shouldOpenDeleteConfirmationPopup: false,
  isLoading: false,
  isLoadingPage: false,
  error: null,
  formFieldValueMap,
  isRateAdminAdvanceRateCreateSuccess: false,
  isRateAdminAdvanceRateCreateError: false,
  isRateAdminAdvanceRateDetailSuccess: false,
  isRateAdminAdvanceRateDetailError: false,
  isRateAdminAdvanceRateEditSuccess: false,
  isRateAdminAdvanceRateEditError: false,
  isRateAdminAdvanceRateExportSuccess: false,
  isRateAdminAdvanceRateExportError: false,
  isPageLevelError: false,
  paginationInfo: null,
  savedTableState: null,
  updateData: null,
  isUpdateFetchSuccess: false,
  isUpdateFetchError: false,
  searchData: null,
  isSearchLoading: false,
  isSearchSuccess: false,
  isSearchError: false,
  isUpdateAdvanceRateSuccess: false,
  isUpdateAdvanceRateError: false,
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      id,
      locationTitle,
      categoryTitle,
      startDate,
      endDate,
    } = item;

    const transformedValues = {
      id: decorateEmptyGridValues(id),
      locationTitle: decorateEmptyGridValues(locationTitle),
      categoryTitle: decorateEmptyGridValues(categoryTitle),
      startDate: decorateEmptyGridValues(startDate ? formatDatesMmDdYyyy(startDate) : null),
      endDate: decorateEmptyGridValues(endDate ? formatDatesMmDdYyyy(endDate) : null),
    };
    return transformedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: true,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Location",
      dataKey: "locationTitle",
      extraProps: {
        isDropDownField: true,
        options: [],
        filterField: 'locationTitle',
        sortField: 'locationTitle',
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Category",
      dataKey: "categoryTitle",
      extraProps: {
        isDropDownField: true,
        options: [],
        filterField: 'categoryTitle',
        sortField: 'categoryTitle',
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Start Date",
      dataKey: "startDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "End Date",
      dataKey: "endDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const rateadminAdvanceRateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RATEADMIN_ADVANCERATE_INIT:
      return { ...INITIAL_STATE, savedTableState: state.savedTableState, isLoadingPage: true };
    
    case FETCH_RATEADMIN_ADVANCERATE_DETAIL.START:
    case EXPORT_RATEADMIN_ADVANCERATE.START:
    case FETCH_RATEADMIN_ADVANCERATE_LIST.START:
    case CREATE_RATEADMIN_ADVANCERATE.START:
    case EDIT_RATEADMIN_ADVANCERATE.START:
    case RATEADMIN_ADVANCERATEDD.START:
    case RATEADMIN_ADVANCERATE_DELETE.START:
      return { ...state, isLoading: true };

    case FETCH_RATEADMIN_ADVANCERATE_LIST.SUCCESS: {
      const { page, data } = action.payload?.data;

      let resetState = {
        rateAdminAdvanceRateListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isRateAdminAdvanceRateCreateSuccess: false,
        isRateAdminAdvanceRateCreateError: false,
        savedTableState: state.savedTableState,
      };
      if (!action.payload?.data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        rateAdminAdvanceRateListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }

    case FETCH_RATEADMIN_ADVANCERATE_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        rateAdminAdvanceRateListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isRateAdminAdvanceRateDeleteSuccess: false,
        isRateAdminAdvanceRateDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_RATEADMIN_ADVANCERATE_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];

            if (key === "endDate") {
              temp[key] = formatDatesMmDdYyyy(action.payload[key]);
            }
            if (key === "startDate") {
              temp[key] = formatDatesMmDdYyyy(action.payload[key]);
            }
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isRateAdminAdvanceRateDetailSuccess: true,
      };
    }
    case FETCH_RATEADMIN_ADVANCERATE_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isRateAdminAdvanceRateDetailSuccess: false,
        isRateAdminAdvanceRateDetailError: true,
      };
    }

    //DD
    case RATEADMIN_ADVANCERATEDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        AdvanceRateDD: temp,
        isRateAdminAdvanceRateDDSuccess: true,
        isRateAdminAdvanceRateDDError: false,
      };
    }
    case RATEADMIN_ADVANCERATEDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isRateAdminAdvanceRateDDSuccess: false,
        isRateAdminAdvanceRateDDError: true,
      };
    }
    //END DD

    // Export Start
    case EXPORT_RATEADMIN_ADVANCERATE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isRateAdminAdvanceRateExportSuccess: false,
        isRateAdminAdvanceRateExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_RATEADMIN_ADVANCERATE.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "advancerate.xls");
      return {
        ...state,
        isRateAdminAdvanceRateExportSuccess: true,
        isRateAdminAdvanceRateExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }
    // Export End

    // EDIT
    case EDIT_RATEADMIN_ADVANCERATE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminAdvanceRateEditSuccess: false,
        isRateAdminAdvanceRateEditError: true,
      };
    }
    case EDIT_RATEADMIN_ADVANCERATE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminAdvanceRateEditSuccess: true,
        isRateAdminAdvanceRateEditError: false,
      };
    }
    // EDIT END

    // CREATE
    case CREATE_RATEADMIN_ADVANCERATE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminAdvanceRateCreateSuccess: false,
        isRateAdminAdvanceRateCreateError: true,
      };
    }
    case CREATE_RATEADMIN_ADVANCERATE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminAdvanceRateCreateSuccess: true,
        isRateAdminAdvanceRateCreateError: false,
      };
    }
    // CREATE END

    // DELETE
    case RATEADMIN_ADVANCERATE_DELETE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminAdvanceRateDeleteSuccess: false,
        isRateAdminAdvanceRateDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case RATEADMIN_ADVANCERATE_DELETE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminAdvanceRateDeleteSuccess: true,
        isRateAdminAdvanceRateDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    // DELETE END

    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup: action.payload,
      };

    case INIT_CREATE_RATEADMIN_ADVANCERATE_SCREEN:
      return {
        ...state,
        formFieldValueMap,
        isRateAdminAdvanceRateCreateSuccess: false,
        isRateAdminAdvanceRateCreateError: false,
        isRateAdminAdvanceRateEditSuccess: false,
        isRateAdminAdvanceRateEditError: false,
        isUpdateAdvanceRateSuccess: false,
        isUpdateAdvanceRateError: false,
      };

    case RATEADMIN_ADVANCERATE_SAVE_TABLE_STATE:
      return {
        ...state,
        savedTableState: {
          ...state.savedTableState,
          ...action.payload,
        },
      };

    case TOAST.RESET:
      return {
        ...state,
        isRateAdminAdvanceRateCreateSuccess: false,
        isRateAdminAdvanceRateCreateError: false,
        isRateAdminAdvanceRateEditSuccess: false,
        isRateAdminAdvanceRateEditError: false,
        isRateAdminAdvanceRateDeleteSuccess: false,
        isRateAdminAdvanceRateDeleteError: false,
        isRateAdminAdvanceRateExportSuccess: false,
        isRateAdminAdvanceRateExportError: false,
      };

    case SEARCH_ADVANCE_RATE.START:
      return {
        ...state,
        isSearchLoading: true,
        isSearchSuccess: false,
        isSearchError: false,
      };

    case SEARCH_ADVANCE_RATE.SUCCESS:
      return {
        ...state,
        isSearchLoading: false,
        searchData: action.payload,
        isSearchSuccess: true,
        isSearchError: false,
      };

    case SEARCH_ADVANCE_RATE.ERROR:
      return {
        ...state,
        isSearchLoading: false,
        searchData: null,
        isSearchSuccess: false,
        isSearchError: true,
      };

    case UPDATE_ADVANCE_RATE.START:
      return {
        ...state,
        isLoading: true,
        isUpdateAdvanceRateSuccess: false,
        isUpdateAdvanceRateError: false,
      };

    case UPDATE_ADVANCE_RATE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isUpdateAdvanceRateSuccess: true,
        isUpdateAdvanceRateError: false,
      };

    case UPDATE_ADVANCE_RATE.ERROR:
      return {
        ...state,
        isLoading: false,
        isUpdateAdvanceRateSuccess: false,
        isUpdateAdvanceRateError: true,
      };

    default:
      return state;
  }
};
